<template>
  <div class="case-info">
    <iframe class="iframe" :src="iframeUrl" frameborder="0"></iframe>
  </div>
</template>

<script>
export default {
  data() {
    return {
      iframeUrl: ''
    }
  },
  created() {
    if (this.isValidUrl(this.$route.query.url)) {
      this.iframeUrl = this.$route.query.url
    } else {
      this.iframeUrl = 'https://www.meihua.info/author/a43ed83a'
    }
  },
  methods: {
    isValidUrl(url) {
      const urlPattern = /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*\/?$/;
      return urlPattern.test(url);
    }
  }
}
</script>

<style>
.case-info {
  width: 100%;
  height: 100vh;
}
.iframe {
  width: 100%;
  height: calc(100% + 502px);
  margin-top: -70px;
}
@media screen and (max-width: 768px) {
  .iframe {
    width: 100%;
    height: calc(100% + 290px);
    margin-top: -51px;
  }
}
</style>